import { render, staticRenderFns } from "./CustomerCandidate.vue?vue&type=template&id=5ff1222f&scoped=true"
import script from "./CustomerCandidate.vue?vue&type=script&lang=js"
export * from "./CustomerCandidate.vue?vue&type=script&lang=js"
import style0 from "./CustomerCandidate.vue?vue&type=style&index=0&id=5ff1222f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1222f",
  null
  
)

export default component.exports